<template>
    <div>
        <activix-select
            class="nav-select"
            :autosize="true"
            :options="orderedDivisions"
            :placeholder="$t('multiselect.selectOption')"
            v-model="selectedDivisionId"
        />
    </div>
</template>

<script>
    import { ActivixSelect } from '@/components/activix-ui/index.ts';
    // Pinia
    import { mapActions, mapState } from 'pinia';
    import { useUserStore } from '@/store/modules/user/store.js';
    import { useFlowStore } from '../store/modules/flow/store.js';
    import { useContextStore } from '../store/modules/context/store.ts';
    import { useAccountStore } from '../store/modules/account/store.js';

    import { sort } from '../utils/index.js';
    import Division from '../entities/Division.js';

    export default {
        components: {
            ActivixSelect,
        },

        data() {
            return {
                selectedDivisionId: null,
            };
        },

        computed: {
            ...mapState(useContextStore, {
                contextDivision: 'contextDivision',
            }),
            ...mapState(useFlowStore, {
                flowService: 'service',
            }),

            contextAccount() {
                return useAccountStore().contextAccount;
            },

            authUser() {
                return useUserStore().authUser;
            },

            showNew() {
                return this.$route.meta.header.division.includes(Division.NEW);
            },

            showUsed() {
                return this.$route.meta.header.division.includes(Division.USED);
            },

            showCredit() {
                return (
                    this.contextAccount.credit &&
                    this.$route.meta.header.division.includes(Division.FINANCE)
                );
            },

            showService() {
                return (
                    this.contextAccount.service || this.authUser.hasDivisionAccess(Division.SERVICE)
                );
            },

            orderedDivisions() {
                const divisions = [];

                if (this.showNew) {
                    divisions.push(Division.NEW);
                }

                if (this.showUsed) {
                    divisions.push(Division.USED);
                }

                if (this.showCredit) {
                    divisions.push(Division.FINANCE);
                }

                if (this.showService) {
                    divisions.push(Division.SERVICE);
                }

                return sort(
                    divisions.map((divisionId) => {
                        return {
                            value: divisionId,
                            label: Division.getTranslation(divisionId),
                        };
                    }),
                    'label'
                );
            },
        },

        watch: {
            'contextDivision.id': {
                immediate: true,
                handler(divisionId) {
                    this.selectedDivisionId = divisionId;
                },
            },

            selectedDivisionId(divisionId) {
                this.setContextDivisionId(divisionId);
            },
        },

        methods: {
            ...mapActions(useContextStore, ['setContextDivisionId']),
        },
    };
</script>
